var _defs, _g, _mask, _use, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.56%",
    y1: ".142%",
    x2: "59.658%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE",
    offset: "58.438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.479%",
    y1: "83.682%",
    x2: "3.177%",
    y2: "14.149%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818CF8",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0.64,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.38%",
    y1: "24.752%",
    x2: "58.769%",
    y2: "81.336%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0.48,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-836.8%",
    y: "-796.7%",
    width: "1767.4%",
    height: "1693.3%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 32,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.168627451 0 0 0 0 0.168627451 0 0 0 0 0.321568627 0 0 0 0.24 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M17.153 30 0 20.07 7.306 0l17.259 2.958L28.8 18.169z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#6366F1",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#312E81",
    filter: "url(#a)",
    cx: 28,
    cy: 28,
    r: 12
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    transform: "rotate(27 -5.674 50.657)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.05-.398 16.218 14.077L33.444 21.3l5.406-10.055-.636-6.668L30.37-.398l-6.042-2.223-10.6-.529L7.05-.398Z",
    fill: "url(#e)",
    mask: "url(#f)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.496 11.7-1.35 20.437l4.558 7.895c4.24 2.596 6.501 4 6.784 4.21.283.21 5.3.21 15.052 0l5.406-6.737-.954-14.105Z",
    fill: "url(#g)",
    mask: "url(#f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    fill: "#6366F1",
    mask: "url(#f)",
    d: "m24.809 2.25-1.488 11.396L16.2 32.85l13.817-3.482 4.039-7.703.744-12.873z"
  })), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.32,
    fill: "#38BDF8",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#h)",
    cx: 13.904,
    cy: 15,
    r: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon04);
export default __webpack_public_path__ + "static/media/features-icon-04.284340a8c539a3aa774f4c9204075e7b.svg";
export { ForwardRef as ReactComponent };